import {Injectable} from '@angular/core';
import barriereFreiheitConfig from '../configs/barrierefreiheit.config.json';
import {DbReaderService} from '../../../services/db-reader/db-reader.service';
import {MatDialog} from '@angular/material/dialog';
import {FormGroup, UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {BarrierefreiheitTextanpassungService} from './textanpassung.service';
import {BehaviorSubject, timer} from 'rxjs';
import {BarrierefreiheitEinstellungenComponent} from '../components/barrierefreiheitEinstellungen/barrierefreiheitEinstellungen.component';

@Injectable({providedIn: 'root'})
export class BarrierefreiheitService {

  public barriereConfig = barriereFreiheitConfig
  public barriereForm: FormGroup
  public unterschiede = new BehaviorSubject<boolean | any[]>(false)
  public neuesForm:any = new BehaviorSubject(barriereFreiheitConfig)

  constructor(
    private dbReader: DbReaderService,
    private dialog: MatDialog,
    private textService: BarrierefreiheitTextanpassungService
  ) {}

  public barriereEinstellungenInit(){
    this.dbReader.get('barrierefreiheit', 'Options').subscribe(barriereFreiheit => {
      if (barriereFreiheit){
        this.setzeNeuesForm(barriereFreiheit)
        this.pruefeAbweichungen(barriereFreiheit)
      } else {
        this.dbReader.add(this.barriereConfig, 'barrierefreiheit', 'Options')
        this.setzeNeuesForm(this.barriereConfig)
      }
      this.serviceListeAusführen()
    })
  }

  public barriereEinstellungenAnzeigen(feldName){
    return this.barriereForm.value[feldName]
  }

  public barriereDialog(){
    this.dialog.open(BarrierefreiheitEinstellungenComponent, {
      width: '800px',
      data: {},
      panelClass: 'mat-barrierefreiheit-container',
      disableClose: true
    })
  }

  public barriereEinstellungenSpeichern(){
    this.serviceListeAusführen()
    this.dbReader.update(this.barriereForm.value, 'barrierefreiheit', 'Options')
    this.pruefeAbweichungen(this.barriereForm.value)
    this.setzeNeuesForm(this.barriereForm.value)
    this.dialog.closeAll()
  }

  public barriereEinstellungenAbbrechen(){
    this.dialog.closeAll()
  }

  public barriereEinstellungenReset(){
    this.setzeNeuesForm(this.barriereConfig)
  }

  public pruefeAbweichungen(config) {
    const keys = Object.keys(config);
    const neuerWert = keys.some(key => config[key] !== this.barriereConfig[key]);
    this.unterschiede.next(neuerWert);
  }

  public setzeNeuesForm(config){
    const newForm = {}
    for (let [key, value] of Object.entries(config)){
      newForm[key] = new UntypedFormControl(value, [])
    }
    this.barriereForm = new UntypedFormGroup(newForm)
    this.neuesForm.next(this.barriereForm.value)
  }

  private serviceListeAusführen(){
    this.textService.textGroesseAendern(this.barriereForm.value['textGroesse'])
  }
}

